import { render } from "./k-app-404.vue?vue&type=template&id=576d4df0"
const script = {}

import "./k-app-404.vue?vue&type=style&index=0&id=576d4df0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__